<template>
    <AppStart />
</template>

<script>
import ANALYTICS from '@generio-ai/library-legacy/constants/analytics'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import AppStart from '@/components/start/AppStart.vue'

export default {
    name: 'ViewStart',
    components: {
        AppStart
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ]),
        ...mapActions('overlay', [
            'hide'
        ]),
    },
    mounted() {
        this.hide()
        this.logEvent({
            name: ANALYTICS.EVENTS.VIEW_OPENED,
            description: 'Start view opened',
        })
    }
}
</script>